import React, { useState, useEffect, useReducer } from "react";
import {
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  CardContent,
  Card,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Button,
  DialogContent,
  Dialog,
  TextField,
  InputLabel,
  FormControl,
  Chip,
  Select,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import PageTitle from "../../components/PageTitle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import useStyles from "../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import "react-datepicker/dist/react-datepicker.css";
import "../../css/employee-page.css";
import { useNotification } from "../../hooks/useNotification.js";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLocation } from "react-router-dom";
import NoDataFound from "../../components/NoDataFound/index.js";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { GoDotFill } from "react-icons/go";
import { IoAddCircleSharp, IoListSharp } from "react-icons/io5";

const useCardStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  card: {
    margin: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    background: "#f8f8f8",
    border: "1px solid #e1e1e1",
  },
  icon: {
    marginRight: theme.spacing(2),
  },
}));

export default function Department() {
  const classes = useStyles();
  const cardClasses = useCardStyles();
  const token = localStorage.getItem("token");
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("userId");
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [levelData, setlevelData] = useState([]);
  const [addDepartmentModal, setAddDepartmentModal] = useState(false);
  const [addDesignationModal, setAddDesignationModal] = useState(false);
  const [departmentId, setDepartmentId] = useState("");

  const levels = {
    Entry: {
      level: "Entry",
      color: "#FA7070",
      fillPercentage: 25,
    },
    Mid: {
      level: "Mid",
      color: "#ff9800",
      fillPercentage: 50,
    },
    Senior: {
      level: "Senior",
      color: "#BBE9FF",
      fillPercentage: 75,
    },
    Special: {
      level: "Special",
      color: "#B4E380",
      fillPercentage: 100,
    },
  };
  const colorCode = [
    "#8E1616",
    "#2A004E",
    "#500073",
    "#C62300",
    "#F14A00",
    "#1E3E62",
    "#0B192C",
    "#003161",
    "#000B58",
    "#435585",
    "#1B4242",
    "#4B70F5",
    "#4C3BCF",
    "#1F6E8C",
  ];
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Department Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Department Name be Alphanumeric",
      }),
  });
  const designationValidationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Designation Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Designation Name be Alphanumeric",
      }),
      levelId: Yup.string()
      .required("Designation Level is required")
      .typeError("Designation Level must be a number"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    register: designationRegister,
    handleSubmit: designationHandleSubmit,
    reset: designationReset,
    control: designationcontrol,
    formState: {
      errors: designationErrors,
      isSubmitting: designationIsSubmitting,
    },
  } = useForm({
    resolver: yupResolver(designationValidationSchema),
  });

  const handleCloseDepartmentAdd = () => {
    setAddDepartmentModal(false);
    reset();
  };

  const handleOpenDesignationAdd = (event, id) => {
    event.stopPropagation();
    setDepartmentId(id);
    setAddDesignationModal(true);
  };

  const handleCloseDesignationAdd = () => {
    setAddDesignationModal(false);
    setDepartmentId("");
    designationReset();
  };

  useEffect(() => {
    fetchDeparmentsData();
    fetchLevelsData();
  }, []);

  const fetchDeparmentsData = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}department/viewAll`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          setDepartmentData(response.data.data);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const fetchLevelsData = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}designation/levelList`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          setlevelData(response.data.data);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleAddDepartment = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}department/create`,
        { ...values },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchDeparmentsData();
        handleCloseDepartmentAdd();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleAddDesignation = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}designation/addDesignation`,
        { departmentId: departmentId, ...values },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        handleCloseDesignationAdd();
        fetchDeparmentsData();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const getLevelStyle = (level) => {
    console.log(level);
    const levelInfo = levels[level];
    return {
      avatar: (
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            border: "1px solid rgb(176 176 176)",
            background: `linear-gradient(to bottom, ${levelInfo.color} ${levelInfo.fillPercentage}%, #ffffff ${levelInfo.fillPercentage}%)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#000",
          }}
        >
          <GoDotFill color="#5b5b5b" />
        </div>
      ),
      label: levelInfo.level,
    };
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Department and Designation" />
        </Grid>
        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <div className={classes.lgButton}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              onClick={(e) => {
                setAddDepartmentModal(true);
              }}
            >
              Add New Department
            </Button>
          </div>

          <div className={classes.smButton}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              color="primary"
              onClick={(e) => {
                setAddDepartmentModal(true);
              }}
            >
              Add
            </Button>
          </div>
        </Grid>
        <Grid item xs={12}>
          {departmentData.map((item) => (
            <Grid item xs={12}>
              <Accordion key={item.id}>
                <AccordionSummary
                  style={{ background: "#96B6C5", color: "#110d65" }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel-content"
                  id={`${item.id}-header`}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    gridGap={10}
                  >
                    <Box display="flex" alignItems="center" gridGap={10}>
                      <IoListSharp size={20} color="#110d65" />
                      <Typography className={cardClasses.heading}>
                        {item.title}
                      </Typography>
                    </Box>

                    <Tooltip placement="right" title="Add New Designation">
                      <Typography
                        component="span"
                        onClick={(e) => handleOpenDesignationAdd(e, item.id)}
                      >
                        <IoAddCircleSharp color="#fff" size={20} style={{borderRadius:"50%",background:"#485e69" }} />
                      </Typography>
                    </Tooltip>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    {item.designations.map((row, index) => {
                      const levelStyle = getLevelStyle(row.level.level);
                      return (
                        <Grid item xs={12} sm={6} md={4} key={row.id}>
                          <Card
                            className={cardClasses.card}
                            style={{
                              borderLeft: `4px solid ${
                                colorCode[index % colorCode.length]
                              }`,
                            }}
                          >
                            <CardContent>
                              <Typography className="fs-5" variant="h5">
                                {row.title}
                              </Typography>
                              <Chip
                                avatar={levelStyle.avatar}
                                label={levelStyle.label}
                              />
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {departmentData.length === 0 && (
        <NoDataFound height="80vh" message="No Data Found" />
      )}

      <Dialog
        maxWidth="xs"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
        open={addDepartmentModal}
        onClose={handleCloseDepartmentAdd}
      >
        <DialogContent>
          <form onSubmit={handleSubmit(handleAddDepartment)}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <p style={{ fontSize: "18px", fontWeight: 600, margin: 0 }}>
                  Add New Department
                </p>
              </Grid>
              <Grid item xs={12}>
                <InputLabel shrink htmlFor="title">
                  Department Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Department Name"
                    name="title"
                    {...register("title")}
                    error={errors.title ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.title?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="end" gridGap={8}>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={handleCloseDepartmentAdd}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    type="submit"
                  >
                    Save
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth="xs"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
        open={addDesignationModal}
        onClose={handleCloseDesignationAdd}
      >
        <DialogContent>
          <form onSubmit={designationHandleSubmit(handleAddDesignation)}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <p style={{ fontSize: "18px", fontWeight: 600, margin: 0 }}>
                  Add New Desingnation
                </p>
                <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>
                  {departmentData.filter(item=>item.id===departmentId)[0]?.title}
                </p>
              </Grid>
              <Grid item xs={12}>
                <InputLabel shrink htmlFor="title">
                  Designation Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Designation Name"
                    name="title"
                    {...designationRegister("title")}
                    error={designationErrors.title ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {designationErrors.title?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <InputLabel shrink htmlFor="level">
                  Designation Level
                </InputLabel>

                <FormControl className={classes.margin}>
                  <Controller
                    name="levelId"
                    control={designationcontrol}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        error={designationErrors.levelId ? true : false}
                        classes={{
                          root: classes.customSelectField,
                          icon: classes.customSelectIcon,
                        }}
                        disableUnderline
                      >
                        <MenuItem value="">Select option</MenuItem>
                        {levelData.map((item) => (
                          <MenuItem value={item.id}>{item.level}</MenuItem>
                        ))}
                      </Select>
                    )}
                  />

                  <Typography variant="inherit" color="error">
                    {designationErrors.level?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="end" gridGap={8}>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={handleCloseDesignationAdd}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    type="submit"
                  >
                    Save
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
